import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vue2TouchEvents from 'vue2-touch-events'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)
Vue.use(Vue2TouchEvents)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  render: h => h(App)
})

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.Vue({
    Vue, attachProps: true
  })],
  //   release: 'feature/sentry-vue',
  environment: process.env.VUE_APP_SENTRY_ENV
})
